import React from "react";
import "./HealthcareHerosection.css";

export default function HealthcareHerosection() {
  return (
    <div id="healthcare-hero" className="outsourcemainclass">
      <div className="left">
        <h1>Healthcare IT Consulting Services</h1>
        <p>
         Empowering better health outcomes through innovative technology breakthroughs that transform care and improve lives.
        </p>
      </div>
    </div>
  );
}
